/*
 唱吧 APP 通用参数 JS Bridge
 规范文档: https://s8qu5yn8sp.feishu.cn/wiki/wikcn8lZfheKp8jOu0w18oaEAmg
*/
// 使用funny兼容3.0 替换
import { getGlobalParams } from '@changba/funny'

export default getGlobalParams
